import * as React from "react"
const FeedIcon = ({
  fill = "currentColor",
  strokeWidth = 0.5,
  strokeColor = "#000",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="_\u30EC\u30A4\u30E4\u30FC_2"
    data-name="\u30EC\u30A4\u30E4\u30FC 2"
    viewBox="0 0 51 30.73"
  >
    <g id="day_mode" data-name="day mode">
      <path
        d="M.5 2.45h50v25.82H.5z"
        style={{
          fill: fill,
          stroke: strokeColor,
          strokeWidth: strokeWidth,
          strokeMiterlimit: 10,
        }}
        transform="rotate(-180 25.5 15.365)"
      />
      <path
        d="M2.8 29.23 11.96 1.5M8.83 29.23 17.99 1.5M14.87 29.23 24.02 1.5M20.9 29.23 30.05 1.5M26.93 29.23 36.09 1.5M32.96 29.23 42.12 1.5M38.99 29.23 48.15 1.5"
        className="cls-1"
      />
    </g>
  </svg>
)
export default FeedIcon
